import TimePanelHeaderButtonWell from './TimePanelHeaderButtonWell';
import { popView, updateCurrentView } from '../actions/timePanelStoreActions';
import { getCurrentPanelViewType, getStackLength } from 'owa-time-panel-view-stack';
import { observer } from 'mobx-react-lite';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';
import {
    backButtonText,
    backButtonTitle,
    calendarPivotText,
    tasksPivotText,
} from './TimePanelHeaderBar.locstring.json';

const styles = require('./TimePanelHeaderBar.scss');

export default observer(function TimePanelHeaderBar() {
    return (
        <div className={styles.container}>
            <div className={styles.headerControl}>
                {getStackLength() > 1 ? (
                    <ActionButton
                        className={styles.backButton}
                        styles={{
                            icon: styles.backButtonIcon,
                        }}
                        text={loc(backButtonText)}
                        title={loc(backButtonTitle)}
                        onClick={popView}
                        iconProps={{ iconName: ControlIcons.Back }}
                    />
                ) : (
                    <Pivot
                        headersOnly={true}
                        onLinkClick={selectPivot}
                        linkSize={PivotLinkSize.normal}
                        selectedKey={getCurrentPanelViewType()}
                        styles={{
                            linkIsSelected: styles.pivotLinkSelected,
                        }}>
                        <PivotItem itemKey={'Calendar'} headerText={loc(calendarPivotText)} />
                        <PivotItem itemKey={'Tasks'} headerText={loc(tasksPivotText)} />
                    </Pivot>
                )}
            </div>
            <TimePanelHeaderButtonWell />
        </div>
    );
});

function selectPivot(item: PivotItem): void {
    switch (item.props.itemKey) {
        case 'Calendar':
            updateCurrentView('Calendar');
            break;
        case 'Tasks':
            updateCurrentView('Tasks');
            break;
        default:
            throw new Error('Not a valid ItemKey: ' + item.props.itemKey);
    }
}
